export default [
    {
        name: 'Transferwise',
        email: 'supportreply@transferwise.com'
    },
    {
        name: 'Remitly',
        email: 'service@remitly.com'
    },
    {
        name: 'Xoom',
        email: 'support@xoom.com'
    },
    {
        name: 'WorldRemit',
        email: 'customerservice@worldremit.com'
    },
    {
        name: 'PingExpress',
        email: 'customerservice@pingexpress.com'
    },
    {
        name: 'MoneyGram',
        email: 'customerservice@moneygram.com'
    },
    {
        name: 'RIA',
        email: 'us_support@riamoneytransfer.com'
    },
    {
        name: 'Azimo',
        email: 'support@azimo.com'
    },
    {
        name: 'Western Union',
        email: 'wucis.customer@westernunion.com'
    },
    {
        name: 'Boss Revolution',
        email: 'support@bossrevolution.com'
    },
    {
        name: 'Kaoshi',
        email: 'support@kaoshinetwork.com'
    },
    {
        name: 'Hygeia HMO',
        email: 'hycare@hygeiahmo.com'
    },
    {
        name: 'AXA Mansard',
        email: 'ccare@axamansard.com'
    }
];
